export default "__VITE_ASSET__3ca75ad9__"